module.exports = __webpack_public_path__ + "static/media/OnlyMARA.ab497ad3.png";